import type { InjectionKey, Ref } from 'vue'

// Shared by every level of a recursive <TodoTree>: which todos are collapsed, plus the actions a
// row can trigger. Provided once by the page that owns the list.
export interface TodoTreeContext {
  calendarId: Ref<number>
  readonly: Ref<boolean>
  collapsed: Ref<Set<string>>
  toggleCollapsed(uid: string): void
  toggleDone(uid: string): void
  open(uid: string): void
  openTag(tag: string): void // the landing page of a tag, `/todos/:calendarId/tag/:tag`
  addSubtask(parentUid: string): void
  reorder(parentUid: string | null, movedUid: string, newIndex: number): void
}

export const TODO_TREE_CONTEXT: InjectionKey<TodoTreeContext> = Symbol('todoTreeContext')
